import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);

import ModuleMain from './imports/module-main';
import ModuleAttachStudio from './imports/module-attach-studio';
import ModuleDiscover from './imports/module-discover';
import ModuleMediaSheet from './imports/module-media-sheet';
import ModuleCreative from './imports/module-creative';

const store = new Vuex.Store({
  modules: {
    main: ModuleMain,
    attachStudio: ModuleAttachStudio,
    creative: ModuleCreative,
    discover: ModuleDiscover,
    mediaSheet: ModuleMediaSheet,
  },
});

export default store;
